import { alignerTotalSuffix } from './alignerTotal';
import { InstructionPill, LatePill } from './ScanPills';
import { scanDecision } from './scanInstructionTone';
import { scanTakenAt } from './scanTakenAt';
import type { DmScanSummary } from './types';

export interface ScanHeaderProps {
    scan: DmScanSummary | null;
    totalAligners?: number | null;
    formatScanDate: (value: string) => string;
    emptyLabel?: string;
}

function ScanHeader({ scan, totalAligners = null, formatScanDate, emptyLabel }: ScanHeaderProps) {
    const row = 'flex items-center justify-between gap-x-2 gap-y-1.5 flex-wrap';

    if (!scan) {
        if (!emptyLabel) return null;
        return (
            <div className={row}>
                <span className="text-xs text-gray-500">{emptyLabel}</span>
            </div>
        );
    }

    return (
        <div className={row}>
            <span className="min-w-0 text-xs text-gray-500">
                {scan.alignerIndex != null && (
                    <>
                        <span className="font-semibold text-gray-700">
                            Aligner {scan.alignerIndex}
                        </span>
                        {alignerTotalSuffix(totalAligners)}
                        {' · '}
                    </>
                )}
                {formatScanDate(scanTakenAt(scan))}
            </span>
            <div className="flex shrink-0 items-center gap-1.5">
                <InstructionPill decision={scanDecision(scan)} />
                <LatePill late={scan.late} daysLate={scan.daysLate} />
            </div>
        </div>
    );
}

export { ScanHeader };
